<!--*
 * Component to show places list
 *
 * @author   mauricio.figueroa
 * @date     2020-07-03
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
-->
<template>
  <div v-if="filteredPlaces.length > 0" class="row">
    <div
      v-for="place in filteredPlaces"
      :key="place.roomAssignmentId"
      class="col--lg--4 col--md--6 col--12 my-4">
      <Place
        :place-name="place.name"
        :out-of-time="place.outOfTime"
        :status="placeStatus(place)"
        :room-id="place.roomId"
        :assignment-id="place.assignmentId"
        :room-assignment-id="place.roomAssignmentId"
        :survey-view-mode="place.isViewMode"
        :room-workflow-phase-name="place.roomWorkflowPhaseName"
        :transition-comment="place.transitionComment"
      />
    </div>
    <slot></slot>
  </div>
</template>

<script>
import Place from './Place';

export default {
  'name': 'PlacesList',
  'props': [ 'places', 'visibilityMode', 'surveyEnabled', 'canAddRoom' ],
  'components': { Place },
  'computed': {
    filteredPlaces() {
      if (this.places.rooms && this.places.rooms.length > 0) {
        if (this.visibilityMode === 'pending') {
          /** NOTE TO THE FUTURE CODE-NAUTA:
           *            Here we're not looking for what rooms are in 'pending' state, we are looking for those rooms
           *            that are not in 'completed' state. Because now on "pending list" we see a lot of states.
           */
          if(this.hasWorkflow) {
            return this.places.rooms.filter((place) => !(place.roomWorkflowPhaseName === 'Finished' || place.recurrent))
          } else {
            return this.places.rooms.filter((place) => !(place.surveyStatus === 2 || place.recurrent));
          }
        } else if (this.visibilityMode === 'completed') {
          if(this.hasWorkflow) {
            return this.places.rooms.filter((place) => place.roomWorkflowPhaseName === 'Finished');
          } else {
            return this.places.rooms.filter((place) => place.surveyStatus === 2);
          }
        } else {
          return this.places.rooms.filter((pl) => pl.recurrent);
        }
      } else {
        return [];
      }
    },
    hasWorkflow() {
      let hasWorkflow = false

      let filteredRooms = this.places.rooms.filter((place) => place.roomWorkflowPhaseName !== null)

      if(filteredRooms.length > 0) {
        hasWorkflow = true
      }

      return hasWorkflow
    }
  },
  'methods': {
    placeStatus(place) {
      // Answer Status and Survey Status:
      // 0: Pending
      // 1: In progress
      // 2: Completed
      // 3: Unassigned
      // 4: In revision
      // 5: Available

      if (place.answerStatus === 2 && place.surveyStatus !== 2) {
        return 'IN_PROGRESS';
      } else if (place.answerStatus === 0) {
        return 'PENDING';
      } else if (this.hasWorkflow && place.roomWorkflowPhaseName === 'Finished') {
        return 'COMPLETED';
      } else if (place.surveyStatus === 2 || place.answerStatus === 2) {
        return 'COMPLETED';
      } else if (place.surveyStatus === 5) {
        return 'AVAILABLE';
      } else {
        return 'IN_PROGRESS';
      }
    },
  }
}
</script>
